import { FunctionComponent } from 'react';
import clsx from 'clsx';
import styles from './FeedingsAndMedicationsInfo.module.scss';
import { faBowlFood } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCapsules } from '@fortawesome/pro-solid-svg-icons';

interface Props {
    hasFeedings: boolean;
    hasMedications: boolean;
}

export const FeedingsAndMedicationsInfo: FunctionComponent<Props> = props => (
    <div className={clsx(styles.serviceDataContainer, styles.feedingAndMedicationsContainer)}>
        <div className={styles.feedingAndMedications}>
            <div className={styles.iconWithText}>
                <FontAwesomeIcon
                    className={styles.icon}
                    icon={faBowlFood}
                />
                <span className={styles.text}>{props.hasFeedings ? 'Yes' : 'No'}</span>
            </div>
            <span className={styles.dot}>·</span>
            <div className={styles.iconWithText}>
                <FontAwesomeIcon
                    className={styles.icon}
                    icon={faCapsules}
                />
                <span className={styles.text}>{props.hasMedications ? 'Yes' : 'No'}</span>
            </div>
        </div>
    </div>
);

export default FeedingsAndMedicationsInfo;
